import { UPDATE_THEME } from '../constants/actionLocal';
import initialState from '../store/initialState';
import { updateObjectInState } from '../helpers/data';

export default (state = initialState.theme, { type, payload }) => {
  switch (type) {
    case UPDATE_THEME:
      return updateObjectInState(state, payload);
    default:
      return state;
  }
};
